var defaultCustomer =  {
      first_name:'',
      last_name: '',
      email: '',
};

var ShopifyCustomers = {
  get(){
    console.log("customers");
    return localStorage.getItem("customers") ? JSON.parse(localStorage.getItem("customers")) : defaultCustomer;
  },
  set(customers){
    localStorage.setItem("customers",JSON.stringify(customers));
  }
};

/*this is admin vue apps*/
/* variables defined in the custom.js*/
app.redirect = false;
adminApp = new Vue({
  el: "#admin-app",

  delimiters: ["${", "}"],
  data: {
    customers: [],
    customer: {
      first_name:'',
      last_name: '',
      email: '',
    },
    isUser: true,
    query: null,
  },

  methods: {

    setCustomer(customer) {
      selectedCustomer.customer = customer;
      selectedCustomer.isUser = true;
      customerData = { ...customer };
      customerData.name = customerData.first_name + ' ' + customerData.last_name;
      customerData.isLoggedIn = sizePopup.isLoggedIn = app.isLoggedIn = true;
      sizePopup.selectedKey = sizeContainerData.selectedKey;
      sizePopup.selectedSize = sizeContainerData.selectedSize;
      sizePopup.showSizePopup = sizeContainerData.showSizePopup;
      sizePopup.fetchDB();
      document.querySelector('.links').classList.remove('op0');
    },
  },
  created(){
    this.customers = ShopifyCustomers.get();
  }
});
selectedCustomer = new Vue({
  el: "#selected-customer-app",

  delimiters: ["${", "}"],
  data: {
    customer: defaultCustomer,
    isUser: false,
  },
  methods: {
    setCustomer(customer) {
      this.customer = customer;
      this.isUser = true;
    }
  },
  created(){
    this.customers = ShopifyCustomers.get();
    $.ajax({
      type: 'get',
      url: "http://themebuz.com/subscription/public/search",
      dataType: 'json',
      success: function(res) {
        console.log('new customer get! ');
        console.log(res);
        adminApp.customers = res.customers;
        ShopifyCustomers.set( res.customers);
        document.querySelector(".mh-admin-app").classList.remove('op0');
      },
      error: function(request, status, error) {
        // if it's not last one Move Along else update the cart number with the current quantity
        // console.log(request.responseText);
        console.log("error");
      }
    });
  }
});

var customerFilter = new Vue({
  el: "#customer-filter",
  delimiters: ["${", "}"],
  data: {
    query: '',
    customers: '',
    filters:'default'
  },
  watch:{
    query(val){
      if (val.length > 1) {
        this.debounceInput();
      }
    },
    filters(val){
      this.order(val);
    }
  },
  methods: {
    debounceInput: _.debounce(function (e) {
       customerFilter.search()
     }, 300),
    search(query){
      $.ajax({
        type: 'POST',
        url: "http://themebuz.com/subscription/public/query",
        dataType: 'json',
        data: {
          query: customerFilter.query
        },
        success: function(res) {
          console.log('customer get!');
          console.log(res);
          adminApp.customers = res.customers;
        },
        error: function(request, status, error) {
          // if it's not last one Move Along else update the cart number with the current quantity
          console.log(request.responseText);
          console.log("error");
        }
      });
    },
    clear(){
      this.query = '';
      adminApp.customers = ShopifyCustomers.get();
    },
    order(query = 'default' ){
      if (query == 'default') {
        adminApp.customers = this.customers;
      } else {
          adminApp.customers =  _.orderBy(adminApp.customers, ['first_name'],[query]);
      }

    },
  },
  mounted(){
    this.customers = adminApp.customers;
  }
});


$(function () {

})
